import {
	USER,
	SETUSER,
	GETUSER,
	AUTH_TOKEN,
	AUTHENTICATED,
	SHOW_AUTH_MESSAGE,
	HIDE_AUTH_MESSAGE,
	SIGNOUT_SUCCESS,
	SIGNUP_SUCCESS,
	SHOW_LOADING,
	SIGNIN_WITH_GOOGLE_AUTHENTICATED,
	SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
	SETREDIRECT,
	SETLOGO,
	HIDE_LOADING,
	SETLOGOACTIVE,
	SETLOGOLINK,
	IS_COMPANY_PAGE,
	SCROLL_TO_LIST,
	COMPANY_SLUG,
	JOB_LIST_PAGE_NUMBER,
	JOB_LIST_PER_PAGE
} from '../constants/Auth';

function lsTest(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}
const initState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: lsTest() && localStorage.getItem('path'),
	token: lsTest() && localStorage.getItem(AUTH_TOKEN),
	user: lsTest() &&  JSON.parse(localStorage.getItem(USER)),
	profile: null,
	logoActive:false,
	logo:'/img/One-ATS.svg',
	logoLink:'/',
	isCompanyPage:false,
	listPosition: 0,
	companySlug: '',
	jobListPage: 0,
	jobListPerPage: 12,
}

const auth = (state = initState, action) => {

	switch (action.type) {
		case AUTHENTICATED:
			return {
				...state,
				loading: false,
				token: action.data.token,
				user: action.data.user
			}
		case GETUSER:{
			return {
				...state
			}
		}
		case SETLOGO:{
			return {
				...state,
				logo:action.payload
			}
		}
		case SETLOGOACTIVE:{
			return {
				...state,
				logoActive:action.payload
			}
		}
		case SETLOGOLINK:{
			return {
				...state,
				logoLink:action.payload
			}
		}
		case SETREDIRECT:{
			return {
				...state,
				redirect:action.payload
			}
		}
		case SETUSER:
			return {
				...state,
				profile: action.data
			}
		case SHOW_AUTH_MESSAGE:
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case HIDE_AUTH_MESSAGE:
			return {
				...state,
				message: '',
				showMessage: false,
			}
		case SIGNOUT_SUCCESS: {
		
			return {
				...state,
				token: null,
				redirect: '/',
				loading: false
			}
		}
		case SIGNUP_SUCCESS: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case HIDE_LOADING: {
			return {
				...state,
				loading: false
			}
		}
		case SIGNIN_WITH_GOOGLE_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case SIGNIN_WITH_FACEBOOK_AUTHENTICATED: {
			return {
				...state,
				loading: false,
				token: action.token
			}
		}
		case IS_COMPANY_PAGE:{
			return{
				...state,
				isCompanyPage: action.isCompanyPage
			}
		}
		case SCROLL_TO_LIST: {
			return {
				...state,
				listPosition: action.listPosition
			}
		}
		case COMPANY_SLUG: {
			return {
				...state,
				companySlug: action.companySlug
			}
		}
		case JOB_LIST_PAGE_NUMBER: {
			return {
				...state,
				loading: false,
				jobListPage: action.jobListPage
			}
		}
		case JOB_LIST_PER_PAGE: {
			return {
				...state,
				loading: false,
				jobListPerPage: action.jobListPerPage
			}
		}
		default:
			return state;
	}
}

export default auth